import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AuthCallback from './pages/AuthCallback';
import ProductPage from './pages/ProductPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import CollectionPage from './pages/CollectionPage';
import MyOrdersPage from './pages/MyOrdersPage';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { ProductsProvider } from './context/ProductsContext';
import { WishlistProvider } from './context/WishlistContext';
import { Toaster } from './components/ui/toaster';

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/product/:id" element={<ProductPage />} />
      <Route path="/collection/:category" element={<CollectionPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order/success/:orderId" element={<OrderSuccessPage />} />
      <Route path="/my/orders" element={<MyOrdersPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-sans">
      <AuthProvider>
        <ProductsProvider>
          <WishlistProvider>
            <CartProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
              <Toaster />
            </CartProvider>
          </WishlistProvider>
        </ProductsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
